import React, { Fragment } from 'react';

function NumberBoxSeparator(Component, digit, index) {
    return function Separator(props) {
        const thousandSeparator = 4;
        const isSeparatorAvailable = digit?.length > thousandSeparator && (digit?.length - thousandSeparator === index);

        return (
            <Fragment key={index}>
                <Component {...props} />
                {isSeparatorAvailable &&
                    <span
                        className={`number-separator ${props?.mode} ${props?.size}`}
                        style={{ ...props?.separatorStyle }}
                    >
                        {props?.separator}
                    </span>}
            </Fragment>
        );
    };
}

export default NumberBoxSeparator;
